/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useNotify from '../../../context/Notification/useNotify';
import { Form, Button } from 'antd';
import IconBack from '../../../assets/Images/icons/icon-back';
import TemplateEmail1 from './components/TemplateEmail1';
import TemplateEmail2 from './components/TemplateEmail2';
import TemplateEmail3 from './components/TemplateEmail3';
import TemplateEmail4 from './components/TemplateEmail4';
import TemplateEmailExtend from './components/TemplateEmailExtend';
import TemplateEmailCancel from './components/TemplateEmailCancel';
import TemplateEmailReassigned from './components/TemplateEmailReassigned';
import TemplateEmailContinue from './components/TemplateEmailContinue';
import TemplateEmailDiscontinue from './components/TemplateEmailDiscontinue';
import TemplateEmailReject from './components/TemplateEmailReject';
import TemplateEmailRemind from './components/TemplateEmailRemind';
import MyTaskService from '../../../services/MyTask.service';
import ModalConfirm from '../../../components/Shared/modal/confirm';
import GlobalService from '../../../services/Global.service';
import { ROUTER } from '../../../constants/router';
import moment from 'moment';

export default function PreviewTemplate({
    values,
    detail,
    setConfirmMode,
    workflowState,
    isCompleteLast,
    setActionMode,
    actionMode,
    setIsAccept,
    contact,
    notes,
    dsFormData,
    departmentSelected,
    cancelDetail,
    operationList,
    remindDetail,
    getMyTaskDetail,
    setEmailList,
    emailList,
    setOperationList,
    setOperationCancelList,
    operationCancelList,
    userApprover,
    emailAssigneesTo,
    emailAssigneesCC,
    setNotes,
}) {
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    const navigate = useNavigate();
    const notify = useNotify();
    let { tab, dsrTaskId } = useParams();
    const [imageUrl, setImageUrl] = useState();

    // Modal Comfirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [valueSave, setValueSave] = useState(false);

    const [imageFile, setImageFile] = useState([]);
    const [docFile, setDocFile] = useState([]);

    const onFinish = async (value) => {
        setOpenConfirm(true);
        const result = dsFormData?.evidenceInformation?.proofOfIdentity?.filter(
            (e) => e?.id !== '0ecb41743d7111edb8780242ac120002'
        );
        const identity = result?.map((e) => e.name);

        if (dsFormData?.evidenceInformation?.proofOfIdentityAddon) {
            identity.push(
                dsFormData?.evidenceInformation?.proofOfIdentityAddon
            );
        }
        const payload = {
            dsrTaskId: dsrTaskId,
            dataSubjectRemark: value.dataSubjectRemark || null, //อีเมลส่งถึงเจ้าของข้อมูล
            operatorRemark: value.operatorRemark || null, ///อีเมลส่งถึงผู้รับผิดชอบในขั้นตอนต่อไป
            dataSubjectEmail: dsFormData?.dataSubjectInformation?.email, //เจ้าของข้อมูล
            delegateEmail: dsFormData?.applicantInformation?.email, //ผู้เปิดคำร้องแทน
            note: notes || null,
            operatorEmailTo: value?.assignTo,
            operatorEmailCc: [],
            departments: departmentSelected,
            fileIds: [],
            assignorEmails: operationList?.emailAssignor || [],
            emailAssigneesTo: value?.emailAssigneesTo || [],
            emailAssigneesCC: value?.emailAssigneesCC || [],
            identity: identity || [],
            noteInPreview: value.noteInPreview || null,
            noteInTaskDetail: value.noteInTaskDetail || null,
        };
        setValueSave(payload);
    };
    const confirmMyTask = async () => {
        setLoading(true);
        // actionMode >>> สำหรับเลือก call service
        // Comfirm,Extend,Cancel,Complete,Reassigned,Continue,Discontinue,Reject
        if (actionMode === 'Confirm') {
            const payload = {
                dsrTaskId: dsrTaskId,
                dataSubjectRemark: valueSave?.dataSubjectRemark || null,
                operatorRemark: valueSave?.operatorRemark || null,
                dataSubjectEmail: valueSave?.dataSubjectEmail || null,
                delegateEmail: valueSave?.delegateEmail || null,
                note: valueSave?.note || null,
                operatorEmailTo: valueSave?.operatorEmailTo || [],
                operatorEmailCc: valueSave?.operatorEmailCc || [],
                departments: valueSave?.departments || [],
                fileIds: valueSave?.fileIds || [],
                requestId: detail?.requestId || null, //คำขอใช้สิทธิ์"
                nextStep: detail?.workflowNextStepNameEn || null,
                dueDate: detail?.dueDate
                    ? moment(detail?.dueDate).format('DD/MM/YYYY')
                    : null,
                dayLeft: detail?.dayLeft,
                createDate: detail?.requestDate
                    ? moment(detail?.requestDate).format('DD/MM/YYYY')
                    : null,
                updateDate: moment(new Date()).format('DD/MM/YYYY') || null,
                dsFirstName:
                    dsFormData?.dataSubjectInformation?.firstName || null,
                dsLastName:
                    dsFormData?.dataSubjectInformation?.lastName || null,
                agentFirstName:
                    dsFormData?.applicantInformation?.firstName || null,
                agentLastName:
                    dsFormData?.applicantInformation?.lastName || null,
                dsType:
                    lang === 'en'
                        ? dsFormData?.dataSubjectInformation
                              ?.dataSubjectNameEn || null
                        : dsFormData?.dataSubjectInformation
                              ?.dataSubjectNameTh || null,
                requestType:
                    lang === 'en'
                        ? dsFormData?.detailsOfClaim?.requestTypeShortName ||
                          null
                        : dsFormData?.detailsOfClaim?.requestTypeShortName ||
                          null,
                purposeForRights: dsFormData?.detailsOfClaim?.purpose || null,
                reasonForRights: dsFormData?.detailsOfClaim?.reason || null,
                evidence: dsFormData?.evidenceInformation?.evidence || false,
                proofOfIdentity: valueSave?.identity || [],
            };
            // console.log('payload ',payload)
            try {
                const { data } = await MyTaskService.confirmMyTask(payload);
                if (data?.resultCode === 1) {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully save data'),
                        timeOut: 1000,
                    });
                    navigate(`${ROUTER.DS_360.MY_TASK}`);
                } else {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('common.FailedSaveData'),
                        timeOut: 120000,
                        closeable: true,
                    });
                }
            } catch (err) {
                console.log(err);
                setLoading(false);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                    timeOut: 120000,
                    closeable: true,
                });
            }
        } else if (actionMode === 'Reject') {
            try {
                const { data } = await MyTaskService.rejectMyTask({
                    dsrTaskId: dsrTaskId,
                    operatorRemark: valueSave?.operatorRemark || null,
                    dataSubjectEmail: valueSave?.dataSubjectEmail || null,
                    delegateEmail: valueSave?.delegateEmail || null,
                });
                if (data?.resultCode === 1) {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully save data'),
                        timeOut: 1000,
                    });
                    navigate(`${ROUTER.DS_360.MY_TASK}?tab=4`);
                } else {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('common.FailedSaveData'),
                        timeOut: 120000,
                        closeable: true,
                    });
                }
            } catch (err) {
                console.log(err);
                setLoading(false);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                    timeOut: 120000,
                    closeable: true,
                });
            }
        } else if (actionMode === 'Continue') {
            try {
                const { data } = await MyTaskService.continueMyTask({
                    dsrTaskId: dsrTaskId,
                    isProcessing: true,
                    reason: valueSave?.dataSubjectRemark || null,
                    dataSubjectEmail: valueSave?.dataSubjectEmail || null,
                    delegateEmail: valueSave?.delegateEmail || null,
                });
                if (data?.resultCode === 1) {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully save data'),
                        timeOut: 1000,
                    });
                    navigate(`${ROUTER.DS_360.MY_TASK}/todolist/${dsrTaskId}`);
                    setConfirmMode(false);
                    getMyTaskDetail();
                } else {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('common.FailedSaveData'),
                        timeOut: 120000,
                        closeable: true,
                    });
                }
            } catch (err) {
                console.log(err);
                setLoading(false);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                    timeOut: 120000,
                    closeable: true,
                });
            }
        } else if (actionMode === 'Discontinue') {
            try {
                const { data } = await MyTaskService.continueMyTask({
                    dsrTaskId: dsrTaskId,
                    isProcessing: false,
                    reason: valueSave?.dataSubjectRemark || null,
                    dataSubjectEmail: valueSave?.dataSubjectEmail || null,
                    delegateEmail: valueSave?.delegateEmail || null,
                });
                if (data?.resultCode === 1) {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully save data'),
                        timeOut: 1000,
                    });
                    navigate(`${ROUTER.DS_360.MY_TASK}/todolist/${dsrTaskId}`);
                    setConfirmMode(false);
                    getMyTaskDetail();
                } else {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('common.FailedSaveData'),
                        timeOut: 120000,
                        closeable: true,
                    });
                }
            } catch (err) {
                console.log(err);
                setLoading(false);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                    timeOut: 120000,
                    closeable: true,
                });
            }
        } else if (actionMode === 'Extend') {
            try {
                const { data } = await MyTaskService.extendMyTask({
                    dsrTaskId: dsrTaskId,
                    operatorRemark: valueSave?.operatorRemark || null,
                    dataSubjectEmail: valueSave?.dataSubjectEmail || null,
                    delegateEmail: valueSave?.delegateEmail || null,
                    notes: valueSave?.note || null,
                });
                if (data?.resultCode === 1) {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully save data'),
                        timeOut: 1000,
                    });
                    navigate(`${ROUTER.DS_360.MY_TASK}/todolist/${dsrTaskId}`);
                    setConfirmMode(false);
                    getMyTaskDetail();
                } else {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('common.FailedSaveData'),
                        timeOut: 120000,
                        closeable: true,
                    });
                }
            } catch (err) {
                console.log(err);
                setLoading(false);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                    timeOut: 120000,
                    closeable: true,
                });
            }
        } else if (actionMode === 'Cancel') {
            const payload = {
                dsrTaskId: dsrTaskId,
                requestId: detail?.requestId,
                noteInPreview: valueSave?.noteInPreview || null,
                emailAssigneesTo: valueSave?.emailAssigneesTo || [],
                noteInTaskDetail: valueSave?.note || null,
                operationTasks: operationCancelList || [],
            };
            try {
                const { data } = await MyTaskService.cancelMyTask(payload);
                if (data?.resultCode === 1) {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully save data'),
                        timeOut: 1000,
                    });
                    navigate(`${ROUTER.DS_360.MY_TASK}?tab=2`);
                } else {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('common.FailedSaveData'),
                        timeOut: 120000,
                        closeable: true,
                    });
                }
            } catch (err) {
                console.log(err);
                setLoading(false);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                    timeOut: 120000,
                    closeable: true,
                });
            }
        } else if (actionMode === 'Complete') {
            const attachFiles = [];
            const fileNames = [];
            const images = [];
            if (docFile) {
                docFile?.forEach((e) => {
                    attachFiles.push(e.fileStorageId);
                    fileNames.push(`${e.fileName}.${e.fileType}`);
                });
            }
            if (imageFile) {
                imageFile?.forEach((e) => {
                    images.push(e.imageId);
                    fileNames.push(`${e.imageName}.${e.imageType}`);
                });
            }
            if (isCompleteLast === false) {
                const payload = {
                    dsrTaskId: dsrTaskId,
                    dataSubjectRemark: valueSave?.dataSubjectRemark || null,
                    operatorRemark: valueSave?.operatorRemark || null,
                    dataSubjectEmail: valueSave?.dataSubjectEmail || null,
                    delegateEmail: valueSave?.delegateEmail || null,
                    attachFiles: attachFiles || [],
                    fileNames: fileNames || [],
                    images: images || [],
                    notes: valueSave?.note || null,
                    assignorEmails: valueSave?.assignorEmails || [],
                    operationTaskId: operationList?.operationTaskId || null,
                    proofOfIdentity: valueSave?.identity || [],
                };
                // console.log('payload not last', payload)

                try {
                    const { data } = await MyTaskService.completeNotLast(
                        payload
                    );
                    if (data?.resultCode === 1) {
                        setLoading(false);
                        setOpenConfirm(false);
                        notify({
                            title: t('common.Success'),
                            description: t('Successfully save data'),
                            timeOut: 1000,
                        });
                        navigate(`${ROUTER.DS_360.MY_TASK}?tab=1`);
                    } else {
                        setLoading(false);
                        setOpenConfirm(false);
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('common.FailedSaveData'),
                            timeOut: 120000,
                            closeable: true,
                        });
                    }
                } catch (err) {
                    console.log(err);
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('common.FailedSaveData'),
                        timeOut: 120000,
                        closeable: true,
                    });
                }
            } else {
                const payload = {
                    dsrTaskId: dsrTaskId,
                    dataSubjectRemark: valueSave?.dataSubjectRemark || null,
                    operatorRemark: valueSave?.operatorRemark || null,
                    dataSubjectEmail: valueSave?.dataSubjectEmail || null,
                    delegateEmail: valueSave?.delegateEmail || null,
                    attachFiles: attachFiles || [],
                    fileNames: fileNames || [],
                    images: images || [],
                    notes: valueSave?.note || null,
                    assignorEmails: valueSave?.assignorEmails || [],
                    proofOfIdentity: valueSave?.identity || [],
                };

                // console.log('payload last',payload)

                try {
                    const { data } = await MyTaskService.completeLast(payload);
                    if (data?.resultCode === 1) {
                        setLoading(false);
                        setOpenConfirm(false);
                        notify({
                            title: t('common.Success'),
                            description: t('Successfully save data'),
                            timeOut: 1000,
                        });
                        navigate(`${ROUTER.DS_360.MY_TASK}?tab=1`);
                    } else {
                        setLoading(false);
                        setOpenConfirm(false);
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('common.FailedSaveData'),
                            timeOut: 120000,
                            closeable: true,
                        });
                    }
                } catch (err) {
                    console.log(err);
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('common.FailedSaveData'),
                        timeOut: 120000,
                        closeable: true,
                    });
                }
            }
        } else if (actionMode === 'Reassigned') {
            const payload = {
                operationTaskId: cancelDetail?.operationTaskId,
                requestId: detail?.requestId,
                emailAssigneesTo: valueSave?.emailAssigneesTo || [],
                emailAssigneesCC: valueSave?.emailAssigneesCC || [],
                approverName: userApprover?.approverName,
                departmentName: userApprover?.departmentName,
                operationTasks: operationList || [],
                noteInPreview: valueSave?.noteInPreview || null,
                noteInTaskDetail: valueSave?.note || null,
            };

            // console.log('Reassigned payload ',payload)
            try {
                const { data } = await MyTaskService.confirmReassign(payload);
                if (data?.resultCode === 1) {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully to confirmed data'),
                        timeOut: 1000,
                    });
                    navigate(`${ROUTER.DS_360.MY_TASK}?tab=1`);
                } else {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to confirmed data'),
                        timeOut: 120000,
                        closeable: true,
                    });
                }
            } catch (err) {
                console.log(err);
                setLoading(false);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to confirmed data'),
                    timeOut: 120000,
                    closeable: true,
                });
            }
        } else if (actionMode === 'Remind') {
            const operation = [];
            detail?.operationTask?.forEach((e) => {
                operation.push({
                    taskStatusName: e?.statusNameEn,
                    departmentName: e?.departmentList
                        ?.map((e) => e?.departmentNameEn)
                        .toString(),
                    // departmentName: e?.departmentList?.map((e) => lang === 'en' ? e?.departmentNameEn : e?.departmentNameTh),
                    operationPersonName: e?.assigneeNameEn || '-',
                });
            });
            const payload = {
                operationTaskId: remindDetail?.operationTaskId || null,
                requestId: detail?.requestId || null,
                emailAssigneesTo:
                    remindDetail?.statusNameEn === 'Task Canceling'
                        ? valueSave?.emailAssigneesTo
                        : valueSave?.operatorEmailTo || [],
                nextStep: detail?.workflowNextStepNameEn || null,
                dueDate: detail?.dueDate
                    ? moment(detail?.dueDate).format('DD/MM/YYYY')
                    : null,
                dayLeft: detail?.dayLeft || null,
                createDate: detail?.requestDate
                    ? moment(detail?.requestDate).format('DD/MM/YYYY')
                    : null,
                dsFirstName:
                    dsFormData?.dataSubjectInformation?.firstName || null,
                dsLastName:
                    dsFormData?.dataSubjectInformation?.lastName || null,
                agentFirstName:
                    dsFormData?.applicantInformation?.firstName || null,
                agentLastName:
                    dsFormData?.applicantInformation?.lastName || null,
                dsType:
                    lang === 'en'
                        ? dsFormData?.dataSubjectInformation
                              ?.dataSubjectNameEn || null
                        : dsFormData?.dataSubjectInformation
                              ?.dataSubjectNameTh || null,
                requestType:
                    lang === 'en'
                        ? dsFormData?.detailsOfClaim?.requestTypeShortName ||
                          null
                        : dsFormData?.detailsOfClaim?.requestTypeShortName ||
                          null,
                purposeForRights: dsFormData?.detailsOfClaim?.purpose || null,
                reasonForRights: dsFormData?.detailsOfClaim?.reason || null,
                evidence: dsFormData?.evidenceInformation?.evidence || false,
                proofOfIdentity: valueSave?.identity || [],
                noteInPreview:
                    remindDetail?.statusNameEn === 'Task Canceling'
                        ? valueSave?.noteInPreview
                        : valueSave.dataSubjectRemark,
                operationTasks: operation,
                isRemindCanceling:
                    remindDetail?.statusNameEn === 'Task Canceling'
                        ? true
                        : false,
            };
            try {
                const { data } = await MyTaskService.confirmRemind(payload);
                if (data?.resultCode === 1) {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully to confirmed data'),
                        timeOut: 1000,
                    });
                    navigate(`${ROUTER.DS_360.MY_TASK}/follow-up/${dsrTaskId}`);
                    setConfirmMode(false);
                    getMyTaskDetail();
                    setOperationList([]);
                    setOperationCancelList([]);
                    setEmailList([]);
                } else {
                    setLoading(false);
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to confirmed data'),
                        timeOut: 120000,
                        closeable: true,
                    });
                }
            } catch (err) {
                console.log(err);
                setLoading(false);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to confirmed data'),
                    timeOut: 120000,
                    closeable: true,
                });
            }
        } else {
            console.log('xx no mode xx');
        }
    };

    useEffect(() => {
        // actionMode >>> สำหรับเลือก call service
        // Confirm,Extend,Cancel,Complete,Reassigned,Continue,Discontinue,Reject
        const getDepartmentEmail = async (departmentIds) => {
            try {
                const { data } = await MyTaskService.getDepartmentEmail({
                    departmentIds,
                });
                if (data?.resultData) {
                    setEmailList(data?.resultData || []);
                }
            } catch (err) {
                console.log(err);
            }
        };
        const getPreviewRemind = async () => {
            const params = {
                previewAction: 'Task Remind',
                operationTaskId: remindDetail?.operationTaskId,
                departmentIds: remindDetail?.departmentId,
            };
            try {
                const { data } = await MyTaskService.getPreviewOperation(
                    params
                );
                if (data?.resultData) {
                    setEmailList(data?.resultData?.emailAssigneesTo || []);
                }
            } catch (err) {
                console.log(err);
            }
        };
        if (actionMode === 'Confirm') {
            getDepartmentEmail(departmentSelected);
        }
        if (actionMode === 'Remind' && remindDetail) {
            if (remindDetail?.statusNameEn !== 'Task Canceling') {
                if (remindDetail?.assigneeEmail) {
                    setEmailList([remindDetail?.assigneeEmail]);
                } else {
                    if (
                        detail?.workflowStepStateNameEn.toLowerCase() ===
                            'complete task' &&
                        remindDetail?.assignee
                    ) {
                        getPreviewRemind();
                    } else {
                        getDepartmentEmail(
                            remindDetail?.departmentList?.map(
                                (e) => e.departmentId
                            )
                        );
                    }
                }
            }
        }
    }, [values, remindDetail, departmentSelected, detail]);

    useEffect(() => {
        if (detail?.logoCompanyId) {
            const getImage = async (id) => {
                try {
                    const { data } = await GlobalService.getImage(id);
                    if (data.resultData?.imageId) {
                        setImageUrl(
                            `data:image/png;base64,${data.resultData?.imageId}`
                        );
                    }
                } catch (error) {
                    console.log(error);
                }
            };
            getImage(detail?.logoCompanyId);
        }
    }, [detail]);

    return (
        <>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                form={form}
                layout="horizontal"
                onFinish={onFinish}
                initialValues={{ imageList: [] }}
            >
                <div className="title flex">
                    <div
                        className="cursor-pointer mr-3"
                        onClick={() => {
                            setConfirmMode(false);
                            setOperationList([]);
                            setOperationCancelList([]);
                            setEmailList([]);
                            setImageFile();
                            setDocFile();
                            setActionMode('');
                            form.resetFields();
                            setNotes('');
                        }}
                    >
                        <IconBack />
                    </div>
                    <span>{t('MyTask.PreviewEmailTemplate')}</span>
                </div>
                <div className="sub-title">
                    <span className="text-sm text-gray-400">
                        {t('Data Subject 360')} / {t('My Task')} /{' '}
                        {lang === 'en'
                            ? workflowState === 'Assign Task'
                                ? 'Assignment Details'
                                : workflowState === 'Complete Task'
                                ? 'Complete Details'
                                : `${workflowState} Details`
                            : workflowState}{' '}
                        /{' '}
                    </span>
                    <span>{t('MyTask.PreviewEmailTemplate')}</span>
                </div>

                <div className="grid grid-cols-10 gap-4">
                    <div className="col-span-1"></div>
                    <div className="col-span-8">
                        <div className="bg-white h-max rounded-xl p-1 px-2 my-4">
                            <div className="flex justify-between items-center">
                                <div className="text-[16px] font-semibold p-4">
                                    {t('MyTask.TemplateEmail')}
                                </div>
                                <div className="flex justify-center items-center p-4 space-x-4">
                                    <Button
                                        type="primary"
                                        size="large"
                                        className="w-32"
                                        ghost
                                        onClick={() => {
                                            setConfirmMode(false);
                                            setOperationList([]);
                                            setOperationCancelList([]);
                                            setEmailList([]);
                                            setImageFile();
                                            setDocFile();
                                            setActionMode('');
                                            form.resetFields();
                                            setNotes('');
                                        }}
                                    >
                                        {t('common.Cancel')}
                                    </Button>
                                    <Button
                                        className="w-32"
                                        htmlType="submit"
                                        size="large"
                                        type="primary"
                                    >
                                        {t('common.Submit')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        {tab === 'todolist' && (
                            <>
                                {/* Comfirm,Extend,Cancel,Complete,Reassigned,Continue,Discontue,Reject */}
                                {workflowState === 'Verification' &&
                                    actionMode === 'Confirm' && (
                                        <TemplateEmail1
                                            form={form}
                                            contact={contact}
                                            dsFormData={dsFormData}
                                            detail={detail}
                                            emailList={emailList}
                                            logoCompany={imageUrl}
                                        />
                                    )}
                                {workflowState === 'Verification' &&
                                    actionMode === 'Continue' && (
                                        <TemplateEmailContinue
                                            form={form}
                                            contact={contact}
                                            dsFormData={dsFormData}
                                            detail={detail}
                                            logoCompany={imageUrl}
                                        />
                                    )}
                                {workflowState === 'Verification' &&
                                    actionMode === 'Discontinue' && (
                                        <TemplateEmailDiscontinue
                                            form={form}
                                            contact={contact}
                                            dsFormData={dsFormData}
                                            detail={detail}
                                            logoCompany={imageUrl}
                                        />
                                    )}
                                {workflowState === 'Verification' &&
                                    actionMode === 'Reject' && (
                                        <TemplateEmailReject
                                            form={form}
                                            contact={contact}
                                            dsFormData={dsFormData}
                                            detail={detail}
                                            logoCompany={imageUrl}
                                        />
                                    )}
                                {(workflowState === 'Assign Task' ||
                                    workflowState === 'Other Task') &&
                                    actionMode === 'Confirm' && (
                                        <TemplateEmail2
                                            form={form}
                                            dsFormData={dsFormData}
                                            detail={detail}
                                            emailList={emailList}
                                        />
                                    )}
                                {workflowState === 'Complete Task' &&
                                    actionMode === 'Complete' &&
                                    isCompleteLast === true && (
                                        <TemplateEmail3
                                            form={form}
                                            contact={contact}
                                            setImageFile={setImageFile}
                                            setDocFile={setDocFile}
                                            imageFile={imageFile}
                                            docFile={docFile}
                                            dsFormData={dsFormData}
                                            detail={detail}
                                            emailList={emailList}
                                            operationList={operationList}
                                            logoCompany={imageUrl}
                                        />
                                    )}
                                {workflowState === 'Complete Task' &&
                                    actionMode === 'Complete' &&
                                    isCompleteLast === false && (
                                        <TemplateEmail4
                                            form={form}
                                            contact={contact}
                                            setImageFile={setImageFile}
                                            setDocFile={setDocFile}
                                            imageFile={imageFile}
                                            docFile={docFile}
                                            dsFormData={dsFormData}
                                            detail={detail}
                                            emailList={emailList}
                                            operationList={operationList}
                                            logoCompany={imageUrl}
                                        />
                                    )}
                                {workflowState === 'Complete Task' &&
                                    actionMode === 'Extend' && (
                                        <TemplateEmailExtend
                                            form={form}
                                            contact={contact}
                                            dsFormData={dsFormData}
                                            detail={detail}
                                            logoCompany={imageUrl}
                                        />
                                    )}
                                {workflowState === 'Complete Task' &&
                                    actionMode === 'Cancel' && (
                                        <TemplateEmailCancel
                                            form={form}
                                            dsFormData={dsFormData}
                                            detail={detail}
                                            emailList={emailList}
                                            operationList={operationCancelList}
                                            logoCompany={imageUrl}
                                        />
                                    )}
                            </>
                        )}
                        {tab === 'cancel-task' && (
                            <>
                                {actionMode === 'Reassigned' && (
                                    <TemplateEmailReassigned
                                        form={form}
                                        detail={detail}
                                        cancelDetail={cancelDetail}
                                        operationList={operationList}
                                        userApprover={userApprover}
                                        emailAssigneesTo={emailAssigneesTo}
                                        emailAssigneesCC={emailAssigneesCC}
                                    />
                                )}
                            </>
                        )}

                        {tab === 'follow-up' && (
                            <>
                                {remindDetail?.statusNameEn ===
                                    'Task Canceling' && (
                                    <TemplateEmailCancel
                                        form={form}
                                        dsFormData={dsFormData}
                                        detail={detail}
                                        emailList={emailList}
                                        operationList={operationCancelList}
                                        logoCompany={imageUrl}
                                    />
                                )}
                                {remindDetail?.statusNameEn !==
                                    'Task Canceling' && (
                                    <TemplateEmailRemind
                                        form={form}
                                        dsFormData={dsFormData}
                                        detail={detail}
                                        emailList={emailList}
                                        logoCompany={imageUrl}
                                    />
                                )}
                            </>
                        )}
                    </div>
                    <div className="col-span-1"></div>
                </div>
            </Form>
            <ModalConfirm
                title={t('common.ConfirmProcess')}
                text={t('MyTask.DoYouWantCompleteData')}
                loading={loading}
                open={openConfirm}
                handelOk={() => {
                    confirmMyTask();
                }}
                handelClose={() => {
                    setOpenConfirm(false);
                }}
            />
        </>
    );
}
